import {
  faBuilding,
  faBuildings,
  faChairOffice,
  faGavel,
  faRocket,
  faShield,
  faUser,
  faUserTie,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import { IconListItemA } from '../models';
import { DialerRole, UserRole, UserType } from '@enrollhere/classes';

export const dialerRoleMap: { [key: string]: Partial<IconListItemA> } = {
  [DialerRole.MARKETING_AGENT]: {
    title: 'Marketing Agent',
    icon: faUsers,
  },
  [DialerRole.SALES_AGENT]: {
    title: 'Sales Agent',
    icon: faUserTie,
  },
  [DialerRole.TEAM_LEAD]: {
    title: 'Team Lead',
    icon: faChairOffice,
  },
};

export const userRoleMap: { [key: string]: Partial<IconListItemA> } = {
  [UserRole.agent]: {
    title: 'Agent',
    icon: faUserTie,
  },
  // employee: {
  //   title: 'Employee',
  //   icon: faUser,
  // },
  [UserRole.admin]: {
    title: 'Admin',
    icon: faRocket,
  },
};

export const userTypeMap: { [key: string]: Partial<IconListItemA> } = {
  [UserType.CONSUMER]: {
    title: 'Consumer',
    icon: faUser,
    color: 'consumer',
  },
  [UserType.AGENT]: {
    title: 'Agent',
    icon: faUserTie,
    color: 'agent',
  },
  [UserType.AGENCY]: {
    title: 'Agency',
    icon: faBuildings,
    color: 'agency',
  },
  [UserType.PUBLISHER]: {
    title: 'Publisher',
    icon: faBuilding,
    color: 'publisher',
  },
  [UserType.CARRIER]: {
    title: 'Carrier',
    icon: faShield,
    color: 'carrier',
  },
  [UserType.EMPLOYEE]: {
    title: 'Employee',
    icon: faShield,
    color: 'employee',
  },
  [UserType.AUTHORITY]: {
    title: 'CMS',
    icon: faGavel,
    color: 'authority',
  },
};
